import { fabric } from "fabric";
import { triggerCanvasInitialized } from "../helpers/canvasHelpers";
import { BasicExtensionFactory, Canvas, FabricData } from "../types/canvasTypes";
import { processLoadedObjects } from "../utils/canvasUtils";

const NAME = "canvas-initializer";

export const createCanvasInitializerExtension: BasicExtensionFactory<{
  initialData: FabricData;
}> = ({ initialData }) => {
  return {
    name: NAME,
    onInit: (canvas) => {
      initCanvasSettings(canvas);
      initExistingData(canvas, initialData);
    },
  };
};

function initCanvasSettings(canvas: Canvas) {
  // Objects should remain in current stack position when selected
  canvas.preserveObjectStacking = true;
  // Save scale with more precise number to avoid changing scale when loading from JSON that leads to different width and height numbers in the inspector
  fabric.Object.NUM_FRACTION_DIGITS = 10;

  initSettingsForText();
  initControlsForSelectionGroup();
}

function initExistingData(canvas: Canvas, data: FabricData | null) {
  canvas.loadFromJSON(data, () => {
    processLoadedObjects(canvas);
    triggerCanvasInitialized(canvas);
  });
}

function initSettingsForText() {
  // @ts-ignore
  fabric.disableStyleCopyPaste = true;
}

function initControlsForSelectionGroup() {
  fabric.Group.prototype.hasControls = false;
}
